module.exports = __webpack_public_path__ + "static/media/marker-cityhub.6d6be442.svg";